import * as Yup from "yup";
import { transformSnakeToCamel, transformModelToJson } from "utils/transform";
import { AdminSchema } from "model/_base";

// Yup Schemas
export const LoginSchema = Yup.object().transform(transformSnakeToCamel).shape({
  accessToken: Yup.string().nullable(),
  refreshToken: Yup.string().nullable(),
  user: AdminSchema.nullable(),
});

export class LoginModel {
  /**
   * Transform json to model
   * @param {object} json - JSON data to transform
   * @returns {object} Transformed model
   */
  static jsonToModel(json) {
    try {
      const model = LoginSchema.cast(json.data, {
        abortEarly: false,
        stripUnknown: true,
      });
      return model;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  /**
   * Transform model to json
   * @param {object} model - Model to transform
   * @returns {object} Transformed JSON
   */
  static modelToJson(model) {
    try {
      return transformModelToJson(model);
    } catch (error) {
      console.error("Error transforming PartnerInfo model to JSON:", error);
      return null;
    }
  }
}
